import React from 'react';
import { ProductThumbnail } from 'components/ProductThumbnail/ProductThumbnail';
import { useAppStore } from 'stores/appStore';
import { useMockupStore } from 'stores/mockupStore';
import styles from '../ExistingSiteStoreReadyStep.scss';

/** Up to this many products render larger, at most two per row; beyond it, up to four per row. */
const COMPACT_GRID_MAX_PRODUCTS = 4;

interface ExistingSiteStoreReadyMockupsPanelProps {
  /** Centered preview grid for the "page ready" task: 2-up (≤4 products) or 4-up (more). */
  gridVariant?: 'default' | 'preview';
}

/** Merchant-facing preview tiles (no faux shopper buy row). */
export function ExistingSiteStoreReadyMockupsPanel({
  gridVariant = 'default',
}: ExistingSiteStoreReadyMockupsPanelProps) {
  const selectedProducts = useAppStore((state) => state.selectedProducts);
  const mockups = useMockupStore((state) => state.mockups);
  const isLoading = useMockupStore((state) => state.isLoading);

  let gridClassName = styles.existingSiteStoreReadyMockupsGrid;
  if (gridVariant === 'preview') {
    gridClassName =
      selectedProducts.length <= COMPACT_GRID_MAX_PRODUCTS
        ? styles.existingSiteStoreReadyMockupsGridTwoUp
        : styles.existingSiteStoreReadyMockupsGridFourUp;
  }

  return (
    <div className={styles.existingSiteStoreReadyMockups}>
      <div className={gridClassName}>
        {selectedProducts.map((product) => {
          const mockupUrl = mockups[product.id]?.url;

          return (
            <div key={product.id} className={styles.existingSiteStoreReadyMockupsItem}>
              <ProductThumbnail
                imageUrl={mockupUrl ?? product.mockupImageUrl}
                isLoading={isLoading && !mockupUrl}
                name={product.name}
                showLabel={false}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
